import { useState } from 'react';
import { toast } from 'react-hot-toast';

export default function BrandingSettingsPage() {
  const [logo, setLogo] = useState<File | null>(null);
  const [fullLogo, setFullLogo] = useState<File | null>(null);
  const [favicon, setFavicon] = useState<File | null>(null);

  const handleSave = async () => {
    // TODO: Wire up to backend upload endpoint when available
    toast.success('Branding settings saved');
  };

  const FileUploadField = ({ label, file, setFile, hint }: {
    label: string;
    file: File | null;
    setFile: (f: File | null) => void;
    hint: string;
  }) => (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">{label}</label>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">{hint}</p>
      <input
        type="file"
        accept="image/*"
        onChange={(e) => setFile(e.target.files?.[0] || null)}
        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 dark:file:bg-blue-900 dark:file:text-blue-300"
      />
      {file && <p className="mt-1 text-xs text-green-600">Selected: {file.name}</p>}
    </div>
  );

  return (
    <div className="max-w-2xl space-y-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Branding</h1>
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Upload your branding assets. These will be used across your country&apos;s white-label portals.
      </p>

      <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-6 space-y-6">
        <FileUploadField
          label="Logo"
          file={logo}
          setFile={setLogo}
          hint="Square logo (min 128x128px). Used in sidebar and compact spaces."
        />
        <FileUploadField
          label="Full Logo"
          file={fullLogo}
          setFile={setFullLogo}
          hint="Wide logo (min 300x80px). Used on login pages and emails."
        />
        <FileUploadField
          label="Favicon"
          file={favicon}
          setFile={setFavicon}
          hint="Browser tab icon (32x32px or 64x64px). .ico or .png format."
        />

        <button
          onClick={handleSave}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm font-medium"
        >
          Save Branding
        </button>
      </div>
    </div>
  );
}
